import { Badge } from "@/components/ui/badge";

export const LIBRARIES = [
  { key: "komponenten", label: "Komponenten" },
  { key: "pruefgruppen", label: "Prüfgruppen" },
  { key: "checkpoints", label: "Prüfpunkte" },
  { key: "maengel", label: "Mängel" },
  { key: "business_rules", label: "Business Rules" },
  { key: "reparatur_pakete", label: "Reparaturpakete" },
  { key: "normen", label: "Normen" },
  { key: "health_rules", label: "Health Rules" },
  { key: "catalogs", label: "CMS-Kataloge" },
];

export const STATUS_TONE = {
  sandbox: "bg-muted text-muted-foreground border-border",
  entwurf: "bg-warning/15 text-[hsl(38_92%_38%)] border-warning/30",
  in_review: "bg-primary/10 text-primary border-primary/30",
  freigegeben: "bg-primary/15 text-primary border-primary/40",
  veroeffentlicht: "bg-success/15 text-success border-success/30",
  archiviert: "bg-muted text-muted-foreground border-border",
};

export function StatusPill({ status, testid }) {
  return (
    <Badge data-testid={testid} variant="outline"
      className={`rounded-md border text-[10px] font-semibold ${STATUS_TONE[status] || STATUS_TONE.sandbox}`}>
      {status}
    </Badge>
  );
}
